<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'SNMPList' }"
                ><i class="fas fa-chevron-left"></i>
              </router-link>
              SNMP
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">SNMP</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="SNMP">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header py-3">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-md-8">
                  <div v-if="organizationId == 1" class="form-group required">
                    <label class="control-label">Audra Name</label>
                    <input
                      v-if="is_edit"
                      type="text"
                      v-model="pre.audraName[value.accountId]"
                      id="accountId"
                      class="form-control accountId"
                      name="accountId"
                      readonly
                    />
                    <multiselect
                      v-else
                      v-model="value.accountId"
                      :options="Object.keys(pre.audraName)"
                      :custom-label="(opt) => pre.audraName[opt]"
                      placeholder="Select Audra Name"
                      :searchable="true"
                      :multiple="false"
                      id="accountId"
                      v-bind:class="{ 'has-error': errors.has('accountId') }"
                      v-validate="'required'"
                      name="accountId"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('accountId')">
                      {{ errors.first("accountId") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Enable</label> <br />
                    <div class="d-flex align-items-center">
                      <label class="radio mr-3">
                        <input
                          type="radio"
                          id="is_enable"
                          name="is_enable"
                          v-model="value.is_enable"
                          v-validate="'required'"
                          class=""
                          value="1"
                        />
                        <span class="radio-mark"></span>
                        Yes
                      </label>
                      <label class="radio">
                        <input
                          type="radio"
                          id="is_enable"
                          name="is_enable"
                          v-model="value.is_enable"
                          v-validate="'required'"
                          class=""
                          value="0"
                        />
                        <span class="radio-mark"></span>
                        No
                      </label>
                    </div>
                    <div class="help text-danger" v-show="errors.has('is_enable')">
                      {{ errors.first("is_enable") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Community</label>
                    <input
                      type="text"
                      id="community"
                      name="Community"
                      v-model="value.community"
                      v-validate="'required'"
                      class="form-control community"
                      placeholder="Community"
                    />
                    <div class="help text-danger" v-show="errors.has('Community')">
                      {{ errors.first("Community") }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Location</label>
                    <input
                      type="text"
                      id="location"
                      name="location"
                      v-model="value.location"
                      class="form-control location"
                      placeholder="Location"
                    />
                  </div>
                  <div class="form-group">
                    <label class="control-label">Contact</label>
                    <input
                      type="text"
                      id="contact"
                      name="contact"
                      v-model="value.contact"
                      class="form-control contact"
                      placeholder="Contact"
                    />
                  </div>
                  <div class="form-group">
                    <label class="control-label">System Name</label>
                    <input
                      type="text"
                      id="system_name"
                      name="system_name"
                      v-model="value.system_name"
                      class="form-control system_name"
                      placeholder="System Name"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "SNMPForm",
  metaInfo: {
    title: "SNMP | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {
      audraName: [],
    },
  }),
  methods: {
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/snmps";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/snmps/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "SNMPList" });
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message);
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message);
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/snmps/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get('accountId') }
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back()
          });
      } else {
        this.value.accountId = LocalStorage.get("accountId");
        this.value.is_enable = 1;
      }

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
    },
  },
  mounted() {
    this.initialize();
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
};
</script>
